import React, { Component } from 'react';
import moreImg from "../../desktop/components/commImg/diandiandian.png";
import PropTypes from "prop-types";
import { connect } from 'react-redux'


/**
 * <Card showMore={true} title={"标题"} style={{marginTop:"20px"}} >  内容 </Card>
 */
class Card extends Component {
    static defaultProps = { showMore: false, moreClick: () => { }, style: {} };
    static propTypes = {
        title: PropTypes.string.isRequired,//标题
        showMore: PropTypes.bool,//是否显示more
        moreClick: PropTypes.func,//点击查看更多
        style: PropTypes.object
    };
    render() {
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        return (
            <div style={{ padding: '0 20px 20px 20px', backgroundColor: "#FFF", ...this.props.style }}>
                <div style={{ height: 58, lineHeight: "54px", position: "relative", borderBottom: "1px solid #f4f6fc", borderRadius: 1 }}>
                    <div style={{ position: "absolute", fontSize: "16px", color: newSecondSelectColor, borderBottom: "3px solid " + newSecondSelectColor, fontFamily: "MicrosoftYaHei" }}><b>{this.props.title}</b></div>
                    {this.props.showMore ? <div onClick={() => { this.props.moreClick() }} style={{
                        fontSize: 13,
                        right: 0,
                        color: '#0050B3',
                        float: 'right',
                        marginRight: 20,
                        cursor: 'pointer'
                    }}><img src={moreImg} alt="" /></div>
                        : null}
                </div>
                <div >
                    {React.Children.map(this.props.children, child => child)}
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(Card);